var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElaborarContratosIndividuales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145 145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b2d7e8;}.cls-2{fill:#f3f3e5;}.cls-3{fill:#d6d5c2;}.cls-4{fill:#6baec9;}.cls-5{fill:#e8b954;}.cls-6{fill:#4c74b6;}.cls-7{fill:#424e5c;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "elaborar_contratos_individuales") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 72.5,
    cy: 72.5,
    r: 72.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.3,22.64H37.07a6.76,6.76,0,0,0-6.76,6.76v77.75a6.76,6.76,0,0,0,0,13.52H87.77a6.76,6.76,0,0,0,6.76-6.76V35.36h6.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M87.77,122.36A8.45,8.45,0,0,1,81,108.84H30.31v-3.38H87.77a1.69,1.69,0,0,1,0,3.38,5.07,5.07,0,1,0,5.07,5.07h3.38A8.46,8.46,0,0,1,87.77,122.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101.3,22.64a6.77,6.77,0,0,0-6.77,6.76V71.65h13.53V29.4A6.76,6.76,0,0,0,101.3,22.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M75.93,68.05,114.69,29.3l6.76,6.76L82.69,74.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M75.94,68.05,70.87,79.88,82.7,74.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M61.56,86.85a2.26,2.26,0,0,1-1.63-.58c-1.78-1.52-.56-4.36,1-7.21,2.53-4.57,3-6.59,3.13-7.38a9.56,9.56,0,0,0-2.41,1.16l-.18.1s-3.17,1.71-7.86,8c-2.57,3.42-5,5-7.33,4.64a5.46,5.46,0,0,1-4-3.33l3.12-1.29c.13.3.66,1.18,1.35,1.27.37,0,1.75-.07,4.19-3.32,4.8-6.4,8.25-8.51,8.93-8.89,1.41-.93,4.73-2.77,6.67-1s1.06,5.07-2.63,11.71a19.52,19.52,0,0,0-1.2,2.48,39.29,39.29,0,0,0,7.12-4.62l2.1,2.65c-5.82,4.6-8.79,5.64-10.36,5.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M50.59,29.4h27v3.38h-27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M55.66,36.16h16.9v3.38H55.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M42.14,44.61H82.7V48H42.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M38.76,51.37H82.7v3.38H38.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M48.9,36.16h3.38v3.38H48.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M75.94,36.16h3.38v3.38H75.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M42.14,58.13H70.87v3.38H42.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M37.07,64.89H55.66v3.38H37.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M62.42,91.94H86.08v3.38H62.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M60.73,98.7H70.87v3.38H60.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M74.25,98.7H89.46v3.38H74.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M45.52,102.08H37.07a1.69,1.69,0,0,1-1.69-1.69V90.25h3.38V98.7h6.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M48.9,98.7h3.38v3.38H48.9Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElaborarContratosIndividuales);
export default __webpack_public_path__ + "static/media/elaborar_contratos_individuales.1e7eb4fefbb9f8800ab66f8f41331795.svg";
export { ForwardRef as ReactComponent };